import React from 'react';

/**
 * Purpose visual for platform-engineering #ai.
 * Copy lives in PLATFORM_ENGINEERING_SECTIONS.ai.architecture.
 * Even grid: stacked on small screens, two then three columns as space allows.
 */
export default function MultiAgentArchitectureSchematic({ steps = [], quote }) {
  return (
    <div className="rounded-2xl border border-ink-200/90 bg-white/80 p-5 shadow-sm ring-1 ring-brand-100/40 sm:p-7">
      <p className="text-xs font-semibold uppercase tracking-widest text-brand-700">Agent architecture</p>
      <ol className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {steps.map((step, i) => (
          <li
            key={step.label}
            className="flex min-w-0 gap-3 rounded-xl border border-ink-200 bg-brand-50/40 px-4 py-4 sm:flex-col sm:gap-2"
          >
            <span className="shrink-0 text-[11px] font-bold tracking-wide text-brand-600">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div className="min-w-0">
              <p className="text-[15px] font-semibold leading-snug text-ink-900">{step.label}</p>
              <p className="mt-1.5 text-sm leading-6 text-ink-600">{step.detail}</p>
            </div>
          </li>
        ))}
      </ol>
      {quote ? (
        <blockquote className="mt-6 border-l-2 border-brand-700 pl-4 text-sm italic leading-relaxed text-ink-800 sm:text-[15px]">
          {quote}
        </blockquote>
      ) : null}
    </div>
  );
}
